import ddmBaseTheme from "./theme.ddm";
import ddmDarkTheme from "./theme.ddm.dark";

const ddmTheme = {
  ...ddmBaseTheme
};

export { ddmTheme, ddmDarkTheme };
